import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col flex-1 min-h-0 overflow-y-auto" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col flex-1 min-h-0 overflow-y-auto"
}
const _hoisted_3 = { class: "flex items-center justify-between flex-shrink-0 h-16 px-6 border-b" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", {
  id: "slide-over-title",
  class: "text-lg font-bold text-gray-900"
}, " Qualification Approval ", -1)
const _hoisted_5 = { class: "flex items-center ml-3 h-7" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Close", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "relative flex-grow" }
const _hoisted_9 = { class: "h-full p-6 bg-gray-100" }
const _hoisted_10 = { class: "mb-8 border-b border-gray-300" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-3 font-medium" }, " Please select up to 10 qualifications", -1)
const _hoisted_12 = { class: "multiselect-multiple-label" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "mb-3 font-medium relative items-center w-full mb-2" }
const _hoisted_15 = {
  key: 0,
  class: "ml-1 text-red-500"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "?", -1)
const _hoisted_17 = ["onUpdate:modelValue", "onChange"]
const _hoisted_18 = { value: "all" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: "each" }, " Answer for each qualification ", -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "mb-4" }
const _hoisted_23 = {
  key: 1,
  class: "flex justify-end flex-shrink-0 px-4 py-4 border-t"
}
const _hoisted_24 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactAdd = _resolveComponent("ContactAdd")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_CheckboxInput = _resolveComponent("CheckboxInput")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ContactAdd, {
        onContactAdded: _ctx.contactAdded,
        onContactCancelled: _ctx.contactCancelled
      }, null, 8, ["onContactAdded", "onContactCancelled"])
    ], 512), [
      [_vShow, _ctx.showAddContact]
    ]),
    (_ctx.qualifications.length && _ctx.contacts.length)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "text-gray-400 bg-white rounded-md hover:text-gray-500 focus:outline-none",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
              }, _hoisted_7)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.selections,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selections) = $event)),
                  options: _ctx.qualifications,
                  mode: "multiple",
                  max: "10",
                  placeholder: "Search qualifications",
                  "value-prop": "product_id",
                  "track-by": "custom_title",
                  label: "custom_title",
                  searchable: true,
                  "close-on-select": false
                }, {
                  multiplelabel: _withCtx(({ values }) => [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(values.length) + " of 10 qualifications selected ", 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])
              ]),
              (_ctx.selections.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: field,
                        class: "p-4 mb-6 bg-white border rounded shadow-sm"
                      }, [
                        _createElementVNode("p", _hoisted_14, [
                          _createTextVNode(_toDisplayString(field.label) + " ", 1),
                          (field.required)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, " * "))
                            : _createCommentVNode("", true),
                          (field.amplification)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: "inline-flex items-center justify-center w-5 h-5 p-2 ml-2 text-sm text-white bg-gray-700 rounded-full cursor-pointer",
                                onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showAmplification=true)),
                                onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showAmplification=false))
                              }, [
                                _hoisted_16,
                                (field.amplification && _ctx.showAmplification)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "absolute left-0 z-50 block w-full p-3 mt-2 mb-6 text-sm text-white bg-gray-700 rounded top-full",
                                      onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAmplification=true)),
                                      onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAmplification=false))
                                    }, _toDisplayString(field.amplification), 33))
                                  : _createCommentVNode("", true)
                              ], 32))
                            : _createCommentVNode("", true)
                        ]),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((field.view) = $event),
                          class: "block px-4 py-2 pr-10 mb-6 border border-gray-300 rounded shadow-sm cursor-pointer focus:ring-brand",
                          onChange: ($event: any) => (_ctx.onChangeInputMethod(field.name, $event.target.value))
                        }, [
                          _createElementVNode("option", _hoisted_18, " Answer for all qualifications (" + _toDisplayString(_ctx.selections.length) + ") ", 1),
                          _hoisted_19
                        ], 40, _hoisted_17), [
                          [_vModelSelect, field.view]
                        ]),
                        (field.view === 'all')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(field.component), {
                                modelValue: _ctx.formValues[field.name],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.formValues[field.name]) = $event),
                                type: field.type,
                                contactadd: field.contactadd,
                                options: field.options,
                                required: field.required,
                                value: field.value,
                                error: _ctx.formErrors[field.name],
                                onChange: ($event: any) => (_ctx.setAll(field.name, $event.target.value)),
                                onInput: ($event: any) => (_ctx.setAll(field.name, $event.target.value)),
                                onBlur: ($event: any) => (_ctx.setAll(field.name, $event.target.value)),
                                onFileUpload: ($event: any) => (_ctx.setAll(field.name, $event.target.files[0].name)),
                                onContactAdd: _ctx.contactAdd
                              }, null, 40, ["modelValue", "onUpdate:modelValue", "type", "contactadd", "options", "required", "value", "error", "onChange", "onInput", "onBlur", "onFileUpload", "onContactAdd"]))
                            ]))
                          : _createCommentVNode("", true),
                        (field.view === 'each')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selections, (selection) => {
                                return (_openBlock(), _createElementBlock("div", { key: selection }, [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent(field.component), {
                                    modelValue: _ctx.formValues[selection + field.name],
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.formValues[selection + field.name]) = $event),
                                    label: _ctx.getQualification(selection).custom_title,
                                    type: field.type,
                                    contactadd: field.contactadd,
                                    options: field.options,
                                    value: field.value,
                                    error: _ctx.formData[selection].errors[field.name],
                                    onChange: ($event: any) => (_ctx.setOne(selection, field.name, $event.target.value)),
                                    onInput: ($event: any) => (_ctx.setOne(selection, field.name, $event.target.value)),
                                    onBlur: ($event: any) => (_ctx.setOne(selection, field.name, $event.target.value)),
                                    onFileUpload: ($event: any) => (_ctx.setOne(selection, field.name, $event.target.files[0].name)),
                                    onContactAdd: _ctx.contactAdd
                                  }, null, 40, ["modelValue", "onUpdate:modelValue", "label", "type", "contactadd", "options", "value", "error", "onChange", "onInput", "onBlur", "onFileUpload", "onContactAdd"]))
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_CheckboxInput, _normalizeProps(_guardReactiveProps(_ctx.declarationSchema)), null, 16)
              ])
            ])
          ])
        ], 512)), [
          [_vShow, !_ctx.showAddContact]
        ])
      : _createCommentVNode("", true),
    (_ctx.qualifications.length && _ctx.contacts.length)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("button", {
            type: "button",
            class: "px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
          }, " Cancel "),
          _createElementVNode("button", {
            type: "submit",
            class: _normalizeClass(["inline-flex justify-center px-4 py-2 ml-4 text-sm font-medium text-white border border-transparent rounded-md shadow-sm bg-brand", !_ctx.formValid ? 'opacity-25' : '']),
            disabled: !_ctx.formValid,
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onSubmit()))
          }, " Save ", 10, _hoisted_24)
        ], 512)), [
          [_vShow, !_ctx.showAddContact]
        ])
      : (_openBlock(), _createBlock(_component_LoadingSpinner, {
          key: 2,
          message: "Loading Section"
        }))
  ], 64))
}